import React from "react";
import classNames from "classnames";
import Button from "../Button/Button";
import { getOtherProperties } from "../common/Utils";
import { ButtonNavigationItemProps } from "./PropsType";

export default function ButtonNavigationItem(props: ButtonNavigationItemProps) {
  const {
    active,
    children,
    className,
    icon,
    label,
    onClick,
    prefixCls = "bm-ButtonNavigationItem",
    ...other
  } = props;
  const styleClass = classNames(prefixCls, className, {
    [`${prefixCls}-active`]: active,
  });
  const otherProps = getOtherProperties(other, ["onClick"]);
  const handleClick = (event: any) => {
    if (props.onClick) {
      (props.onClick as (event: any) => void)(event);
    }
  };
  return (
    <Button className={styleClass} onClick={handleClick} {...otherProps}>
      <span className={`${prefixCls}-inner`}>
        {icon}
        <span>{label}</span>
        {children}
      </span>
    </Button>
  );
}
